"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VSearchSelectFieldAsync = void 0;
var core_1 = require("@blueprintjs/core");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var FormFieldContainer_1 = require("../FormFieldContainer");
var SelectSelectionInfo_1 = require("../SearchSelect/SelectSelectionInfo");
var style_1 = require("../style");
var VSearchSelectFieldAsyncContext_1 = require("./context/VSearchSelectFieldAsyncContext");
var useSearchSelectFieldAsync_1 = require("./hook/useSearchSelectFieldAsync");
var styled_1 = require("./styled");
var VSearchSelectFieldAsyncItems_1 = require("./VSearchSelectFieldAsyncItems");
var Popover = core_1.Popover;
exports.VSearchSelectFieldAsync = (0, mobx_react_1.observer)(function (_a) {
    var id = _a.id, label = _a.label, placeholder = _a.placeholder, noLabel = _a.noLabel, labelInfo = _a.labelInfo, layer = _a.layer, required = _a.required, validators = _a.validators, displayRequired = _a.displayRequired, popoverWidth = _a.popoverWidth, className = _a.className, isLoading = _a.isLoading, inline = _a.inline, margin = _a.margin, value = _a.value, allowEmpty = _a.allowEmpty, fieldState = _a.fieldState, fill = _a.fill, tooltip = _a.tooltip, rightIcon = _a.rightIcon, placeholderSearch = _a.placeholderSearch, suppessLeftIconSearch = _a.suppessLeftIconSearch, _b = _a.multi, multi = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.popoverMinimal, popoverMinimal = _d === void 0 ? true : _d, _e = _a.amountCharacterSearch, amountCharacterSearch = _e === void 0 ? 3 : _e, onChange = _a.onChange, onLoadData = _a.onLoadData, allowFirstLoad = _a.allowFirstLoad, tipLabel = _a.tipLabel, tipBgColor = _a.tipBgColor, sort = _a.sort;
    var _f = (0, useSearchSelectFieldAsync_1.useSearchSelectFieldAsync)({
        multi: multi,
        disabled: disabled,
        required: required,
        validators: validators,
        fieldState: fieldState,
        value: value,
        isLoading: isLoading,
        onChange: onChange,
        onLoadData: onLoadData,
        allowFirstLoad: allowFirstLoad,
        sort: sort
    }), text = _f.text, count = _f.count, isOpen = _f.isOpen, options = _f.options, isValue = _f.isValue, loading = _f.loading, selection = _f.selection, refInputSearch = _f.refInputSearch, isDisabledPopover = _f.isDisabledPopover, onSearchData = _f.onSearchData, deselectAllItems = _f.deselectAllItems, onTogglePopover = _f.onTogglePopover, onOpeningPopover = _f.onOpeningPopover, onClearSearchData = _f.onClearSearchData, changePopoverView = _f.changePopoverView, handleInteraction = _f.handleInteraction, onChangeFirstLoad = _f.onChangeFirstLoad, selectDeselectItem = _f.selectDeselectItem;
    return (react_1.default.createElement(VSearchSelectFieldAsyncContext_1.VSearchSelectFieldAsyncContext.Provider, { value: {
            isOpen: isOpen,
            options: options,
            selection: selection,
            loading: loading,
            refInputSearch: refInputSearch,
            amountCharacterSearch: amountCharacterSearch,
            onSearchData: onSearchData,
            onChangeFirstLoad: onChangeFirstLoad,
            onClearSearchData: onClearSearchData,
            changePopoverView: changePopoverView,
            selectDeselectItem: selectDeselectItem
        } },
        react_1.default.createElement(styled_1.VSearchSelectBody, null,
            react_1.default.createElement(Popover, __assign({}, { isOpen: isOpen }, { targetClassName: 'gsi-select-popover', popoverClassName: 'bp3-select-popover gsi-select-popover', enforceFocus: false, autoFocus: false, canEscapeKeyClose: true, captureDismiss: true, minimal: popoverMinimal, interactionKind: core_1.PopoverInteractionKind.CLICK, modifiers: {
                    flip: { enabled: true },
                    keepTogether: { enabled: true },
                    preventOverflow: { enabled: true }
                }, shouldReturnFocusOnClose: false, onOpening: onOpeningPopover, onInteraction: handleInteraction, position: core_1.Position.BOTTOM_LEFT, disabled: isDisabledPopover, content: react_1.default.createElement(VSearchSelectFieldAsyncItems_1.VSearchSelectFieldAsyncItems, __assign({}, {
                    id: id,
                    multi: multi,
                    popoverWidth: popoverWidth,
                    allowEmpty: allowEmpty,
                    placeholderSearch: placeholderSearch,
                    suppessLeftIconSearch: suppessLeftIconSearch
                })) }),
                react_1.default.createElement("div", { onClick: onTogglePopover },
                    react_1.default.createElement(style_1.StyledInput, __assign({}, {
                        className: className,
                        disabled: disabled,
                        inline: inline,
                        labelInfo: labelInfo,
                        layer: layer,
                        fill: fill,
                        noLabel: noLabel,
                        margin: margin
                    }, { intent: fieldState && fieldState.hasError
                            ? core_1.Intent.DANGER
                            : core_1.Intent.NONE, labelFor: id }),
                        react_1.default.createElement(FormFieldContainer_1.FormFieldContainer, __assign({}, { noLabel: noLabel, label: label, fieldState: fieldState, tooltip: tooltip }, { required: required || displayRequired }),
                            tipLabel && (react_1.default.createElement("span", { className: 'tipLabel', style: {
                                    backgroundColor: tipBgColor ? tipBgColor : '#fff'
                                } }, tipLabel)),
                            react_1.default.createElement(core_1.InputGroup, __assign({}, {
                                id: id,
                                label: label,
                                placeholder: placeholder,
                                required: required,
                                disabled: disabled
                            }, { className: !(loading || isLoading)
                                    ? "gsi-input-select input-search-select2"
                                    : core_1.Classes.SKELETON, autoFocus: false, defaultValue: text, rightElement: react_1.default.createElement(SelectSelectionInfo_1.SelectSelectionInfo, __assign({}, { count: count, deselectAllItems: deselectAllItems, rightIcon: rightIcon }, { disabled: disabled, multi: multi, allowEmpty: allowEmpty && isValue && !disabled })) })))))))));
});
